// src/api/eventsService.ts
import { Event, CreateEvent, EventType } from '../types/Event';
import { ApiResponse } from '../types/ApiResponse';
import { getData, postData, putData } from './apiService';

export const getEvents = async (): Promise<Event[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData('/events', {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Event[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch events:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const getEvent = async (event_id: string): Promise<Event | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/events/${event_id}`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Event;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const getEventByCode = async (code: string): Promise<Event | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/events/code/${code}`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Event;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const getEventsByHostId = async (hostId: string): Promise<Event[]> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await getData(`/hosts/${hostId}/events`, { });  
      // Assuming the API returns an array of events in response.data
      return response.data as Event[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch events:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };
  

  export const getEventTypes = async (): Promise<EventType[]> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await getData(`/event-types`, { });  
      // Assuming the API returns an array of events in response.data
      return response.data as EventType[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event types:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const updateEvent = async (event_id: string, event: Event): Promise<Event | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await putData(`/events/${event_id}`, event);  
      // Assuming the API returns an array of events in response.data
      return response.data as Event;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event types:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const getEventTypeById = async (event_type_id: string): Promise<EventType | null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await getData(`/event-types/${event_type_id}`, { });  
      // Assuming the API returns an array of events in response.data
      return response.data as EventType;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event types:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const eventControlAction = async (event_id: string, action: string): Promise<null> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await postData(`/events/${event_id}/${action}`, { });  
      // Assuming the API returns an array of events in response.data
      return response;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event types:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const sendCreateEventToServer = async (createEventObject: CreateEvent): Promise<Event> => {
    try {
      // Dynamically insert hostId into the URL path
      const response = await postData(`/events`, createEventObject);  
      // Assuming the API returns an array of events in response.data
      return response.data as Event;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event types:', error);
      throw error;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  }
  
  